import { ActionReducerMap, createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromLeadsList from '@crm/ngrx/reducers/leads-list.reducer';

export interface State {
  leadsList: fromLeadsList.State;
}

export const reducers: ActionReducerMap<State, any> = {
  leadsList: fromLeadsList.reducer
};

export const selectLeadsListState = createFeatureSelector<fromLeadsList.State>('leadsList');

/** Select All Tasks */
export const selectAllTasks = createSelector(
  selectLeadsListState,
  fromLeadsList.selectAllTasks
);

/** Select Filter */
export const selectFilter = createSelector(
  selectLeadsListState,
  (state) => state.filter
);

/** Select Loading */
export const selectLoading = createSelector(
  selectLeadsListState,
  (state) => state.loading
);

/** Select Pagination */
export const selectPagination = createSelector(
  selectLeadsListState,
  (state) => state.pagination
);

/** Select Task By ID */
export const selectTaskById = (taskId: string) => createSelector(
  selectLeadsListState,
  (state) => state.entities[taskId]
);
